import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

const CUPRA_MODELS = ['ateca', 'born', 'formentor', 'leon', 'tavascan', 'terramar'] as const;

export const searchToolCupraSchema: ToolSchema = {
  type: 'function',
  name: 'search_cupra_data',
  description:
    'Search CUPRA brochure and pricelist data. Use for factual questions about models, prices, equipment, performance, charging, dimensions and technical details.',
  parameters: {
    type: 'object',
    properties: {
      query: {
        type: 'string',
        description: 'Search query for retrieving relevant CUPRA data'
      },
      model: {
        type: 'string',
        enum: [...CUPRA_MODELS],
        description: 'Optional model filter to narrow results to one CUPRA model'
      }
    },
    required: ['query'],
    additionalProperties: false
  }
};

export const searchToolCupraImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const query = typeof args?.query === 'string' ? args.query.trim() : '';
    const model = typeof args?.model === 'string' ? args.model.trim().toLowerCase() : undefined;

    if (!query) {
      return {
        success: false,
        error: 'Invalid query parameter. Expected a non-empty string.'
      };
    }

    if (model && !CUPRA_MODELS.includes(model as (typeof CUPRA_MODELS)[number])) {
      return {
        success: false,
        error: `Invalid model. Allowed values: ${CUPRA_MODELS.join(', ')}`
      };
    }

    const baseUrl = ''; // Azure Functions are same-origin under the web app API
    const response = await fetch(`${baseUrl}/api/cupra/search`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, model })
    });

    if (!response.ok) {
      const details = await response.text();
      return {
        success: false,
        error: details || 'CUPRA search API request failed.'
      };
    }

    const payload = await response.json();
    const resultText = payload?.result;
    if (!resultText || typeof resultText !== 'string') {
      return {
        success: false,
        error: 'CUPRA search API returned invalid result payload.'
      };
    }

    return {
      success: true,
      data: resultText
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error during CUPRA data search'
    };
  }
};

